import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

declare var window: any;

@Injectable({
    providedIn: 'root'
})
export class MapLoaderService {
    private static promise;
    map: google.maps.Map;
    places: google.maps.places.PlacesService;

    public static load(language) {
        const apiKey = environment.SERVER_URL === 'https://www.yephome.com.au' ? 'AIzaSyAffcIz1dwq1dTkg5I6jVZjE8pA3Tud190' : 'AIzaSyDcJtULjSS8WugtQ0E7r-cmAcNWcD2P_rw';

        if (!MapLoaderService.promise) { // load once
            MapLoaderService.promise = new Promise((resolve, reject) => {
                window.__onGapiLoaded = (ev) => {
                    resolve(window.gapi);
                };
                const node = document.createElement('script');
                node.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&language=${language}&region=au&libraries=places&callback=__onGapiLoaded`;
                node.type = 'text/javascript';
                document.body.appendChild(node);


            }).catch((err) => {
                console.log(err);
            });
        }
        return MapLoaderService.promise;
    }

    initMap(language) {
        return MapLoaderService.load(language).then((gapi) => {
        });
    }
}
